export const NexusMark = ({ size = 40, dark = false, className = "" }) => (
  <span
    className={`relative grid place-items-center rounded-full shrink-0 ${dark ? "bg-[var(--navy)] text-[var(--gold-2)]" : "bg-[var(--gold)] text-[var(--navy)]"} ${className}`}
    style={{ width: size, height: size }}
    aria-hidden
    data-testid="nexus-mark"
  >
    <span className={`absolute inset-[3px] rounded-full border ${dark ? "border-[rgba(241,214,142,.45)]" : "border-[rgba(7,20,22,.28)]"}`} />
    <span className="font-serif font-bold leading-none" style={{ fontSize: size * 0.5, transform: "translateY(1px)" }}>N</span>
    <span className={`absolute rounded-full ${dark ? "bg-[var(--gold-2)]" : "bg-[var(--navy)]"}`} style={{ width: size * 0.12, height: size * 0.12, right: size * 0.17, top: size * 0.17 }} />
  </span>
);
